window.sfDocumentReady(['route-approvals-matrix'], () => {
  const abnResults = {};

  $('.js-product-types').select2({
    width: '100%',
    matcher: createSelect2CharactersMatcher()
  });

  $('.matrix-form .js-search').on('click', async function () {
    try {
      $(this).attr('disabled', true);

      // Prepare form data
      const form = $(this).closest('form');
      const formData = getFormData(form, {
        lists: ['product_types']
      });

      formData.property_ownership = Boolean(_.get(formData, 'property_ownership'));
      formData.abn_result = getAbnResult(formData.abn);
      formData.system_cost_include_gst = formData.system_cost_include_gst === 'on'
        ? true
        : false;

      setListStatus('pending');
      displayApprovals([]);
      displayErrors(null);

      const response = await Api.post('approvals/matrix', formData);
      const data = _.get(response, 'data.data', {});

      const abnResult = _.get(data, 'abnResult');
      abnResults[formData.abn] = abnResult;
      setAbnName(abnResult);

      const approvals = _.get(data, 'approvals', []);
      if (displayApprovals(approvals).length) {
        setListStatus('listed');
      } else {
        setListStatus('empty');
      }
    } catch (err) {
      const status = _.get(err, 'response.status');
      const message = _.get(err, 'response.data.message', err.message);

      if (status === 422) {
        displayErrors(_.get(err, 'response.data.errors', []));
        return setListStatus('input-error');
      } else if (!ajaxErrorHandler(status)) {
        notifyBox(`Error (${status})`, message, 'error');
      }

      setListStatus('error');
    } finally {
      $(this).attr('disabled', false);
    }
  });

  $('#abn').on('change', e => setAbnName(getAbnResult(e.target.value)));

  const getAbnResult = abn => _.get(abnResults, abn);
  const setAbnName = abnResult => $('#abn-name').html(_.get(abnResult, 'name', ''));
  const displayApprovals = approvals => {
    $('.list__item').remove();

    const templateHTML = $('.list__template').html();
    const items = _.map(approvals, approval => {
      const item = $('<div />', {
        class: 'list__item'
      }).html(templateHTML);

      approval.calculator_url = approval.url
        ? `<a href="${approval.url}" target="_blank">
            Repayments &nbsp;<i class="fa fa-external-link"></i>
          </a>`
        : ''

      item.find('[data-template-attr]').each(function () {
        const attr = $(this).data('template-attr');

        $(this).html(_.get(approval, attr, ''));
      });

      return item;
    });

    $('.matrix-list').append(items);
    $('#listed__count').html(items.length);

    return items;
  };
  const setListStatus = status => {
    $('.matrix-list').attr('class', `matrix-list matrix-list--${status}`);
    if (['listed', 'reviewed'].includes(status)) {
      $('.matrix-list').removeClass('matrix-list--has-status');
    } else {
      $('.matrix-list').addClass('matrix-list--has-status');
    }

    toggleVisibility('list_status', status);
  };
  const getListStatus = () => _.get($('.matrix-list').attr('class').match(/matrix-list--([\w-]+)/), 1, 'idle')
  const displayErrors = errors => {
    $(`.js-display-errors`).html('');
    _.each(errors, (fieldErrors, fieldName) => {
      $(`#${fieldName.replace(/\.[^.]+$/, '')}-err`).html(_.get(fieldErrors, 0, ''));
    });
  };
  const getFormData = (form, options = {}) => {
    const formFields = $(form).serializeArray();
    const data = {};
    // for example, multi-select
    const listFields = _.get(options, 'lists', [])

    _.each(formFields, field => {
      if (!listFields.includes(field.name)) {
        data[field.name] = field.value;
      } else {
        if (typeof data[field.name] === 'undefined') {
          data[field.name] = [];
        }

        data[field.name].push(field.value);
      }
    });

    return data;
  };
  const getRadioValue = (name) => $(`[name="${name}"]:checked`).val();

  setListStatus(getListStatus())
  toggleVisibility('product_status', getRadioValue('product_status'));
  $('[name="product_status"]').on('change', () => {
    const productStatus = getRadioValue('product_status');

    toggleVisibility('product_status', productStatus);
    if (`${productStatus}` === '1') { // status is new, reset product year
      $('[name="product_year"]').val('')
    }
  });
});

window.sfDocumentReady(['route-approvals-matrixLogs'], () => {
  const optionsDataTable = {
    columnDefs: [
      {
        orderable: false,
        targets: [-1, 'no-sort']
      },
      {
        type: "date",
        targets: 0
      },
    ],
  }
  window.setupDatatable('.js-datatable', 'desc', 0, optionsDataTable);
});
